import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  APP_TYPE,
  getAppType,
  getCartByCustomer,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { ReactComponent as CartIcon } from '@zonofi/svg-icons/cart.svg';
import { FIELD_OPS_ROUTES, SELLER_WEBAPP_ROUTES } from '../../constants';
import './cart-icon-button.scss';
import { TouchableOpacity } from '../../common';

interface CartIconButtonProps {
  customerId?: string;
  color?: string;
  cartStyle?: string;
  cartCount?: string;
}

export const CartIconButton: React.FC<CartIconButtonProps> = ({
  customerId,
  color = '#ffffff',
  cartStyle = '',
  cartCount = '',
}) => {
  const navigate = useNavigate();
  const appType = useAppSelector(getAppType);
  const customerCart = useAppSelector((state) =>
    getCartByCustomer(state, customerId ?? '')
  );

  const onCartPress = () => {
    if (appType === APP_TYPE.FIELDS_OPS) {
      navigate(
        FIELD_OPS_ROUTES.OFFLINE_CART.replace(':customerId', customerId ?? '')
      );
    } else if (appType === APP_TYPE.SELLER_HUB) {
      navigate(
        SELLER_WEBAPP_ROUTES.CART.replace(':customerId', customerId ?? '')
      );
    }
  };

  const count = cartCount !== '' ? cartCount : customerCart?.lines?.length;

  return (
    <TouchableOpacity
      className={`cart-icon ${cartStyle}`}
      onPress={onCartPress}
      style={{
        backgroundColor:
          appType === APP_TYPE.SELLER_HUB
            ? 'rgba(255, 255, 255, 0.1490196078)'
            : '#ffffff40',
      }}
    >
      <CartIcon color={color} />
      {count ? (
        <div className="cart-icon-count font-regular">{count}</div>
      ) : null}
    </TouchableOpacity>
  );
};
